/*
 * The legal pages are also served from their own subdomain, terms.tapleagues.com,
 * which links in emails and prompts point at. On that host a legal page is shown
 * on its own: no app bar, no drawer, no footer. Anything else on that host (a
 * link inside the terms to /contact, say) renders as the normal site.
 *
 * Pure, so the decisions are tested without a Nuxt runtime; the global middleware
 * termsHost.global.js applies them.
 */

export const TERMS_HOST_LAYOUT = 'bare';
export const TERMS_HOST_HOME = '/legal/terms';

// "terms." as the first label, so terms.tapleagues.com and any environment's
// terms.<env> host both count, and terms.localhost works for local testing.
export const isTermsHost = (hostname) =>
    typeof hostname === 'string' && hostname.toLowerCase().startsWith('terms.');

export const isLegalPath = (path) =>
    typeof path === 'string' && (path === '/legal' || path.startsWith('/legal/'));

// The layout a route on this host should use, or null for its own.
export const termsHostLayout = (hostname, path) =>
    isTermsHost(hostname) && isLegalPath(path) ? TERMS_HOST_LAYOUT : null;

// The bare host has no home page of its own: it opens on the terms.
export const termsHostRedirect = (hostname, path) =>
    isTermsHost(hostname) && (path === '/' || path === '') ? TERMS_HOST_HOME : null;
